/**
 * @fileoverview RecentDealsHeader component
 * Displays the header section of the recent deals slideout with title and action button
 * Provides navigation back to the deal list view
 */

import { Typography } from '@makemydeal/dr-ui-bricks-components';
import { Action } from '@interstate/components/Action';
import { ArrowTopRightOnSquareIcon } from '@interstate/components/Icons/ArrowTopRightOnSquareIcon';

/**
 * RecentDealsHeader component
 * Renders the header of the recent deals slideout containing:
 * - A title (typically "Recent Deals")
 * - A clickable action button that redirects to the full deals list
 *
 * @param title - The header title text
 * @param redirectToDealList - Callback function to navigate to full deals list
 * @returns A header section with styled typography and action button
 */
export const RecentDealsHeader: React.FC<{ title: string; redirectToDealList: () => void }> = ({ title, redirectToDealList }) => {
    return (
        <>
            <Typography className="recent-deals-title" variant="h5">
                {title}
            </Typography>
            <Action
                actionIcon={{
                    end: true,
                    icon: <ArrowTopRightOnSquareIcon />
                }}
                onClick={redirectToDealList}
            >
                Deal List
            </Action>
        </>
    );
};
